import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * When the account is banned, blocks the UI except navigation to technical support and logout.
 */
const BannedGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, isAuthenticated, logout } = useAuth();
  const location = useLocation();

  const banned = isAuthenticated && user?.isBanned === true;
  const onSupportPath =
    location.pathname.startsWith('/teknik-destek');
  if (!banned) {
    return <>{children}</>;
  }

  if (onSupportPath) {
    return (
      <>
        <div className="alert alert-danger m-0 rounded-0 border-0 text-center py-2 small" role="alert">
          <strong>Hesabınız engellenmiştir.</strong> Yalnızca destek talebi oluşturabilirsiniz.
          {user?.banReason ? ` Gerekçe: ${user.banReason}` : null}
        </div>
        {children}
      </>
    );
  }

  return (
    <>
      <div
        className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center p-3"
        style={{ zIndex: 9999, backgroundColor: 'rgba(0,0,0,0.55)' }}
      >
        <div className="card shadow-lg" style={{ maxWidth: '420px' }}>
          <div className="card-body text-center">
            <h5 className="card-title text-danger">Hesabınız engellenmiştir</h5>
            <p className="card-text small text-muted">
              {user?.banReason ?? 'Platform kurallarına aykırı davranış nedeniyle hesabınız kısıtlandı.'}
            </p>
            <div className="d-grid gap-2">
              <Link to="/teknik-destek" className="btn btn-primary">
                Teknik destek / talep oluştur
              </Link>
              <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => logout()}>
                Çıkış yap
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="invisible" aria-hidden>
        {children}
      </div>
    </>
  );
};

export default BannedGuard;
